import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Label, Container, Col, Input, Form, FormGroup, Row } from 'reactstrap';
import './App.css';

// https://css-tricks.com/intro-firebase-react/
class Login extends Component {
  constructor(args) {
    super(args);
    this.state = {
      "email": "",
      "pwd": ""
    };
  }
  
  printProps() {
    console.log(this.props);
    // this.props.signIn('google')
  }

  setField = (e) => {
    if( (e.target.id !== 'teamPrivate') && (e.target.id !== 'isPublic')  ) {
      this.setState({[e.target.id]: e.target.value});
    }
  }

  change = (event) => {
    // this.setState({rootGoal: event.target.value});
  }

  handleSubmit = (e) => {
    //alert('A name was submitted: ' + this.state.goalName);
    e.preventDefault();
  }

  render() {
    return (
      <Container>
        
        <Form onSubmit={this.handleSubmit}>
        <Row>
        <Col>
          <p>Hier könnt Ihr Euch anmelden. E-Mail muss nicht stimmen, sie dient nur dazu, dass ihr voneinander unterscheidbar seid. Ihr könnt auch Euren Namen @family.de nehmen.</p>
          <FormGroup>
              <Label for="email">Email</Label>
              <Input onChange={this.setField} type="text" name="email" id="email" value={this.state.email}/>
          </FormGroup>
          <FormGroup>
              <Label for="pwd">Pwd</Label>
              <Input onChange={this.setField} type="password" name="pwd" id="pwd" value={this.state.pwd}/>
          </FormGroup>
          </Col>
          </Row>
          <Row>
            <Col xs="6"><Button onClick={() => {this.props.signIn('email', this.state.email, this.state.pwd)}}>Loslegen</Button></Col>
            <Col xs="6"><Button onClick={() => {this.props.signUp('email', this.state.email, this.state.pwd)}}>Registrieren</Button></Col>
          </Row>

        </Form>
      </Container>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/Login.js